import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-warning-list',
  templateUrl: './warning-list.component.html',
  styleUrls: ['./warning-list.component.css']
})
export class WarningListComponent implements OnInit {

  @Input()
  message:String;
  constructor() { }

  ngOnInit() {
  }

}
